import React from 'react';

interface ArterraLogoProps {
  className?: string;
  size?: number;
}

export const ArterraLogo: React.FC<ArterraLogoProps> = ({ className = '', size = 40 }) => {
  const width = (size * 100) / 113;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 113"
      width={width}
      height={size}
      className={className}
      fill="none"
    >
      {/* Outer hexagon */}
      <polygon
        points="50,5 95,31 95,82 50,108 5,82 5,31"
        stroke="#E9A634"
        strokeWidth="7"
        strokeLinejoin="round"
        strokeLinecap="round"
        fill="none"
      />

      {/* Three isometric cubes */}
      <g stroke="#E9A634" strokeWidth="4" strokeLinejoin="round" strokeLinecap="round" fill="none">
        {/* Top cube */}
        <polygon points="50,30 64,38 50,46 36,38"/>
        <polygon points="36,38 50,46 50,60 36,52"/>
        <polygon points="64,38 50,46 50,60 64,52"/>

        {/* Bottom-left cube */}
        <polygon points="36,52 50,60 36,68 22,60"/>
        <polygon points="22,60 36,68 36,82 22,74"/>
        <polygon points="50,60 36,68 36,82 50,74"/>

        {/* Bottom-right cube */}
        <polygon points="64,52 78,60 64,68 50,60"/>
        <polygon points="50,60 64,68 64,82 50,74"/>
        <polygon points="78,60 64,68 64,82 78,74"/>
      </g>
    </svg>
  );
};

export default ArterraLogo;
